import React, { useState, useEffect, useContext } from "react";
import { theme } from "../theme";
import FloatButton from "../components/ui/FloatButton";
import { useNavigate } from "react-router-dom";
import { General } from "../tools/styles";
import styled from "styled-components";
import RenderIf from "../components/RenderIf";
import VertSed from "./VertSed";
import HorSed from "./HorSed";
import HydroSed from "./HydroSed";
import BioSed from "./BioSed";
import DashedButton from "../components/ui/DashedButton";
import { WatchContext } from "../WatchContext";
import BackToDash from "../components/BackToDash";

const Styles = {
  ButtonRow: styled.div`
    display: flex;
  `,
  TallDiv: styled.div`
    margin: 2rem 1rem;
    color: ${({ theme }) => theme.colors.grey5};
    font-size: 2rem;
    line-height: 4rem;
  `,
  ColoredH1: styled.h2`
    color: ${({ color }) => color};
    display: inline;
    text-align: center;
  `,
};

const Sediment = () => {
  const navigate = useNavigate();

  let { sediment, vertsed, horsed, biosed, hydrosed, setSediment } =
    useContext(WatchContext);

  let { pdeGreen, pdeOrange, grey4 } = theme.colors;

  const [showSelected, setshowSelected] = useState(null);

  const handleSelect = (item) => {
    let { type } = item;
    switch (type) {
      case "vertsed": {
        return setshowSelected(<VertSed />);
      }
      case "horsed": {
        return setshowSelected(<HorSed />);
      }
      case "hydrosed": {
        return setshowSelected(<HydroSed />);
      }
      case "biosed": {
        return setshowSelected(<BioSed />);
      }
      case "deselect":
      default: {
        return setshowSelected(null);
      }
    }
  };

  let topicButtons = [vertsed, horsed, hydrosed, biosed];

  let dashedElems = topicButtons.map((item, i) => (
    <RenderIf key={i} isTrue={!item.complete}>
      <DashedButton
      key={i}
        borderColor={pdeGreen}
        handleClick={() => handleSelect(item)}
      >
        <Styles.ColoredH1 color={pdeGreen}> + {item.title}</Styles.ColoredH1>
      </DashedButton>
    </RenderIf>
  ));

  let solidElems = topicButtons.map((item, i) => (
    <RenderIf key={i} isTrue={item.complete}>
      <FloatButton key={i} handleClick={() => handleSelect(item)}>
        <Styles.ColoredH1 color={grey4}>{item.title}</Styles.ColoredH1>
      </FloatButton>
    </RenderIf>
  ));

  useEffect(() => {
    const checkComplete = () => {
      let complete = topicButtons.filter((topic) => !!topic.complete);

      if (topicButtons.length === complete.length) {
        setSediment({ ...sediment, complete: 100 });
      } else {
        setSediment({
          ...sediment,
          complete: (complete.length / topicButtons.length) * 100,
        });
      }
    };
    checkComplete();
  }, [vertsed, horsed, biosed, hydrosed]);

  let wordingArray = [
    { a: "Accumulation", b: "Vertical", c: "Horizontal Sediment" },
    {
      a: "High Marsh Delivery",
      b: "Vertical Sediment",
      c: "Sediment Availabilty",
    },
    { a: "High Marsh Integrity", b: "Vertical Sediment", c: "Decomposition" },
    {
      a: "Low Marsh Delivery",
      b: "Horizontal Sediment",
      c: "Sediment Availabilty",
    },
    { a: "Low Marsh Integrity", b: "Horizontal Sediment", c: "Decomposition" },
    {
      a: "Accumulation Resilience",
      b: "Sediment Availabilty",
      c: "Decomposition",
    },
  ];

  let sentences = wordingArray.map((item, i) => (
    <p key={i}>
      <b>{item.a}</b> considerations are generated using the data provided
      for <b>{item.b}</b> and <b>{item.c}</b>
    </p>
  ));

  return (
    <General.Background backgroundColor={`${pdeGreen + 40}`}>
      <General.Heading color={pdeGreen}>{sediment.title}</General.Heading>
      <h2 style={{ color: sediment.complete ? pdeGreen : pdeOrange }}>
        The sediment attributes are{" "}
        {sediment.complete ? "complete" : "incomplete"}.
      </h2>
      <p style={{ textAlign: "center" }}>
        Select an attribute to enter data.
        <br /> Deselect attribute to view the list of comparisons used for
        calculations.
      </p>
      <Styles.ButtonRow>
        {dashedElems}
        {solidElems}
        <RenderIf isTrue={showSelected}>
          <Deselect handleSelect={handleSelect} />
        </RenderIf>
      </Styles.ButtonRow>
      <RenderIf isTrue={showSelected}>
        {showSelected}
        <p>Scroll back to the top to choose another sediment attribute.</p>
      </RenderIf>
      <RenderIf isTrue={!showSelected}>
        <Styles.TallDiv>
          {sentences}
        </Styles.TallDiv>
      </RenderIf>
      <RenderIf isTrue={showSelected}>
        <Styles.ButtonRow>
          {dashedElems}
          {solidElems}
          <RenderIf isTrue={showSelected}>
            <Deselect handleSelect={handleSelect} />
          </RenderIf>
        </Styles.ButtonRow>
      </RenderIf>
      <BackToDash />
    </General.Background>
  );
};

export default Sediment;

const Deselect = ({ handleSelect }) => (
  <FloatButton value={{ type: "deselect" }} handleClick={handleSelect}>
    <Styles.ColoredH1 color={theme.colors.grey4}>
      Close Selection
    </Styles.ColoredH1>
  </FloatButton>
);
